import { APIModelAttributes } from '@ardoq/api-types';
import { fetchEntities } from './api';

export const modelApi = {
  fetchAll: fetchEntities<APIModelAttributes>('model'),
};
